/** @jsx jsx */
import { jsx } from '@emotion/core';
import React, { Component } from 'react';
import { Column, Row } from '../../../../../styles/Grid';
import * as Styles from './index.style';

import DateInput from '../../../DateInput';
import { Select } from '../../../../ui/NewForm';
import { Formik } from 'formik';
import Axios from 'axios';
import { get } from 'lodash';
// import AutoInput from './AutoInput';
import AutoInput from '../../../BookAVisit/AutoInput';
import moment from 'moment';
import { compose } from 'lodash/fp';
import { withNamespaces } from 'react-i18next';
import AnimFormButton, { FormStateArr } from '../../../AnimFormButton';
import * as Yup from 'yup';

const formSchema = Yup.object().shape({
  location: Yup.string().required('This is a mandatory field'),
  people: Yup.string().required('This is a mandatory field'),
  // people: Yup.number()
  //   .notOneOf([0], 'This is a mandatory field')
  //   .typeError('This is a mandatory field'),
});

import LocationIcon from './LocationIcon.svg';

const isTestMode = false;

function findNextInstanceInDaysArray() {
  if (moment().day() === 6 || moment().day() === 0) {
    // saturday, show monday
    // set to monday
    return moment().weekday(8);
  } else {
    // other days, show next day
    return moment();
  }
}
class BookMeetingForm extends Component {
  state = {
    locationText: '',
    locationData: [],
    formState: FormStateArr.DEFAULT,
  };
  cancelTokenSource = false;
  fetchLocationData = async keyword => {
    const { fields, setFieldValue, lng } = this.props;

    this.setState(() => ({
      locationText: keyword,
    }));

    if (this.cancelTokenSource) {
      // Cancel request
      this.cancelTokenSource.cancel();
    }

    if (isTestMode === false) {
      if (keyword.length > 2) {
        // setFieldValue('location', keyword);
        // this.setState(() => ({
        //   formState: FormStateArr.PROGRESS,
        // }));

        let LocationApiURL = get(fields, 'LocationApiUrl.value', '');
        let NoMatchingLocationsText = get(
          fields,
          'NoMatchingLocationsText.value',
          '',
        );
        // "/api/v1/autocomplete-location?term={keyword}&amp;lang={lang}"
        if (LocationApiURL) {
          LocationApiURL = LocationApiURL.split('&amp;').join('&');
          // LocationApiURL = LocationApiURL.replaceAll('&amp;', '&');
          LocationApiURL = LocationApiURL.replace('{keyword}', keyword);
          LocationApiURL = LocationApiURL.replace('{lang}', lng);
        }
        try {
          this.cancelTokenSource = Axios.CancelToken.source();

          const res = await Axios.get(window.location.origin + LocationApiURL, {
            cancelToken: this.cancelTokenSource.token,
          });
          // let suggestionsList = [{ Name: NoMatchingLocationsText, value: '' }];
          let suggestionsList = [];
          if (res.status === 200) {
            if (res.data.length > 0) {
              suggestionsList = res.data.map(item => {
                item.value = item.Name;
                return item;
              });
            }
          }
          this.setState(() => ({
            locationData: suggestionsList,
            // formState: FormStateArr.DEFAULT,
          }));
        } catch (error) {
          this.setState(() => ({
            locationData: [],
            // formState: FormStateArr.ERROR,
          }));
        }
      } else {
        // setFieldValue('location', '');
        this.setState(() => ({
          locationData: [],
          // formState: FormStateArr.DEFAULT,
        }));
      }
    } else {
      let result = [
        {
          TemplateId: 'fe19a179-5452-43e6-8651-8496fdfc510d',
          Name: 'London Bridge, City of London, United Kingdom',
          Url: '/en-gb/united-kingdom/london/city-of-london/london-bridge',
          ItemId: '1a7d57cd-76a6-48c5-9407-b595acd64256',
          Latitude: 51.505992,
          Longitude: -0.088051,
          ItemType: 1,
        },
        {
          TemplateId: 'fe19a179-5452-43e6-8651-8496fdfc510d',
          Name: 'London, Ontario, Canada',
          Url: '/en-gb/canada/london',
          ItemId: 'bdb61823-03f3-4110-a120-443ef1fec4ef',
          Latitude: 42.985977,
          Longitude: -81.247254,
          ItemType: 1,
        },
        {
          TemplateId: 'fe19a179-5452-43e6-8651-8496fdfc510d',
          Name: 'London, United Kingdom',
          Url: '/en-gb/united-kingdom/london',
          ItemId: 'af196125-ce80-4f84-b0c3-c4706da9f21a',
          Latitude: 51.5074,
          Longitude: -0.1278,
          ItemType: 1,
        },
        {
          TemplateId: 'fe19a179-5452-43e6-8651-8496fdfc510d',
          Name: 'London, Ontario, Canada',
          Url: '/en-gb/canada/london',
          ItemId: 'bdb61823-03f3-4110-a120-443ef1fec4ef',
          Latitude: 42.985977,
          Longitude: -81.247254,
          ItemType: 1,
        },
        {
          TemplateId: 'fe19a179-5452-43e6-8651-8496fdfc510d',
          Name: 'London, United Kingdom',
          Url: '/en-gb/united-kingdom/london',
          ItemId: 'af196125-ce80-4f84-b0c3-c4706da9f21a',
          Latitude: 51.5074,
          Longitude: -0.1278,
          ItemType: 1,
        },
      ];

      let suggestionsList = result.map(item => {
        item.value = item.Name;
        return item;
      });

      this.setState(() => ({
        locationData: suggestionsList,
        locationText: keyword,
      }));
    }
  };

  onLocationSelect = async (selectedItem, clearNextInput) => {
    this.setState({
      locationData: [],
      locationText: selectedItem.Name,
    });
  };

  onSubmit = (values, actions) => {
    // "https://www.regus.com/booking/#/meeting-room?paginationSize=100&amp;searchRangeInMilesTo=2&amp;locale={locale}&amp;countryCode={countryCode}&amp;location={location}&amp;countryName={countryName}&amp;centreNumber="
    const { fields } = this.props;
    // console.log('zz onSubmit fields>', fields);
    // console.log('zz onSubmit values>', values);
    // actions.setSubmitting(false);
    // return;

    let targetURL = get(fields, 'TargetUrl.value', '');
    let locale = this.props.lng;
    let countryCode = this.props.DomainCountryISOCode2 || '';
    let countryName =
      values.location && values.location.split(',').pop().trim();
    let date = values.date
      ? moment(values.date, 'DD/MM/YYYY').format('YYYY-MM-DD')
      : findNextInstanceInDaysArray().format('YYYY-MM-DD');

    targetURL = targetURL.replaceAll('&amp;', '&');
    targetURL = targetURL.replace('{locale}', locale);
    targetURL = targetURL.replace('{countryCode}', countryCode);
    targetURL = targetURL.replace('{location}', values.location);
    targetURL = targetURL.replace('{countryName}', countryName);
    targetURL = targetURL.replace('{date}', date);
    targetURL = targetURL.replace('{numberOfPeople}', values.people);

    // console.log('zz targetURL', encodeURI(targetURL));
    window.location = encodeURI(targetURL);
  };

  onFocus = () => {
    this.setState({
      formState: FormStateArr.DEFAULT,
      alert: { msgType: '', msg: '' },
    });
  };

  prepareDropDown = () => {
    const { fields } = this.props;
    // PeopleOptions
    const PeopleOptions = get(fields, 'PeopleOptions', []);
    let tempArr = PeopleOptions.map(item => {
      // [{ value: 1, label: '4 people' }]
      return { value: item.fields.Value.value, label: item.fields.Text.value };
    });

    return tempArr;
  };

  getLocationPermission = formikProps => {
    if (window.navigator.geolocation) {
      var options = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0,
      };

      let success = async pos => {
        const { fields } = this.props;
        let apiUrl = get(fields, 'FindGeoResultsByLatLngApiUrl.value', '');
        apiUrl = apiUrl
          .replace('{latitude}', pos.coords.latitude)
          .replace('{longitude}', pos.coords.longitude);
        this.cancelTokenSource = Axios.CancelToken.source();

        try {
          const response = await Axios({
            method: 'get',
            url: window.location.origin + apiUrl,
            cancelToken: this.cancelTokenSource.token,
          });

          if (response.status == 200) {
            let locationName =
              response.data.Data.AreaName +
              ', ' +
              response.data.Data.CountryLongName;
            formikProps.setFieldValue('location', locationName);
            this.setState({ locationText: locationName });
          }
        } catch (error) {
          this.setState(() => {
            formikProps.setFieldValue('location', '');
            this.setState({ locationText: '' });
          });
        }
      };

      let errors = err => {
        formikProps.setFieldTouched('location', true, false);
        formikProps.setFieldError('location', err.message);
        formikProps.setFieldValue('location', '', false);
        this.setState({ locationText: '' });
        console.warn(`ERROR(${err.code}): ${err.message}`);
      };

      const _this = this;

      window.navigator.permissions
        .query({ name: 'geolocation' })
        .then(function (result) {
          console.log('-- -- --', result);
          if (result.state === 'granted') {
            console.log(result.state);
            //If granted then you can directly call your function here
            window.navigator.geolocation.getCurrentPosition(success);
          } else if (result.state === 'prompt') {
            window.navigator.geolocation.getCurrentPosition(
              success,
              errors,
              options,
            );
          } else if (result.state === 'denied') {
            //If denied then you have to show instructions to enable location
            // window.alert('user denied');
            formikProps.setFieldTouched('location', true, false);
            formikProps.setFieldError('location', 'user denied');
            formikProps.setFieldValue('location', '', false);
            _this.setState({ locationText: '' });
          }
          result.onchange = function () {
            console.log(result.state);
          };
        });
    } else {
      // window.alert('Sorry Not available!');
      formikProps.setFieldTouched('location', true, false);
      formikProps.setFieldError('location', 'Sorry Not available!');
      formikProps.setFieldValue('location', '', false);
      this.setState({ locationText: '' });
    }
  };

  render() {
    const { isDarkMode, fields } = this.props;
    console.log('zxx BookMeeting', this.props);

    const isFindGeoResultsByLatLngServiceEnabled = get(
      fields,
      'IsFindGeoResultsByLatLngServiceEnabled.value',
      '',
    );
    const Title = get(fields, 'Title.value', '');
    const LocationWatermark = get(fields, 'LocationWatermark.value', '');
    const PeopleWatermark = get(fields, 'PeopleWatermark.value', '');
    const CTAText = get(fields, 'CTAText.value', '');
    const DateWatermark = get(fields, 'DateWatermark.value', '');
    // const LocationApiUrl = get(fields, 'LocationApiUrl.value', '');
    // const SubmissionEndpointApiUrl = get(fields, 'SubmissionEndpointApiUrl.value', '');

    const { locationText, locationData, formState } = this.state;
    return (
      <div
        css={[
          Styles.commonCss,
          isDarkMode ? Styles.DarkModeCss : Styles.LightModeCss,
        ]}
      >
        <h3>{Title}</h3>

        <Formik
          initialValues={{ date: '', people: '', location: '' }}
          onSubmit={this.onSubmit}
          validationSchema={formSchema}
        >
          {props => (
            <form
              onSubmit={props.handleSubmit}
              data-formname="bookAMeetingRoom"
            >
              <Row>
                <Column className="tabbox" cols={{ sm: 12, md: 4, lg: 6 }}>
                  <DateInput
                    // initialValue={moment()}
                    initialValue={findNextInstanceInDaysArray()}
                    dateEnableFrom={moment().subtract(1, 'day')}
                    disablePastDt={current => {
                      if (current.isAfter(moment().subtract(1, 'day'))) {
                        return (
                          current.isoWeekday() !== 6 &&
                          current.isoWeekday() !== 7
                        );
                      } else {
                        return false;
                      }
                    }}
                    {...props}
                    SelectDateButtonText={DateWatermark}
                    onInputFocus={this.onFocus}
                  />
                </Column>
                <Column className="customdd" cols={{ sm: 12, md: 4, lg: 6 }}>
                  <div className="select">
                    <Select
                      // className="select_sec-"
                      options={this.prepareDropDown()}
                      id="people"
                      error={props.errors.people && props.touched.people}
                      errorMessage={props.errors.people}
                      placeholder={PeopleWatermark}
                      onChangeProp={props.handleChange}
                      onFocusSelect={this.onFocus}
                      // customIconCss={Styles.selectIconCss}
                    />
                  </div>
                </Column>
                <Column className="mb16" cols={{ sm: 12, md: 12, lg: 12 }}>
                  <AutoInput
                    inputIcon={
                      <img
                        hidden={!isFindGeoResultsByLatLngServiceEnabled}
                        aria-hidden={true}
                        src={LocationIcon}
                        alt="icon"
                        onClick={() => this.getLocationPermission(props)}
                      />
                    }
                    inputPlaceHolder={LocationWatermark}
                    setFieldValue={props.setFieldValue}
                    className="select_location"
                    inputName="location"
                    inputHiddenName="locationId"
                    handleChange={props.handleChange}
                    value={locationText}
                    errors={props.errors}
                    touched={props.touched}
                    suggestions={locationData}
                    fetchSuggestions={this.fetchLocationData}
                    onSelect={this.onLocationSelect}
                    onFocusInput={this.onFocus}
                  />
                  <input
                    name="locationId"
                    type="hidden"
                    className="select_location1"
                    value={props.values.locationId}
                  />
                </Column>

                <Column className="ctasubmit" cols={{ sm: 12, md: 12, lg: 12 }}>
                  <AnimFormButton
                    label={CTAText}
                    // formState={FormStateArr.DEFAULT}
                    formState={formState}
                    // onClick={props.submitForm}
                    buttonProps={{
                      type: 'submit',
                      disabled: props.isSubmitting,
                      onClick: this.onFocus,
                      className: 'submit_btn',
                      css: [],
                    }}
                  />

                  {/* <button className="submit_btn" type="submit">
                    {CTAText}
                  </button> */}
                </Column>
              </Row>
            </form>
          )}
        </Formik>
      </div>
    );
  }
}

BookMeetingForm.displayName = 'FeatureHeros/BookMeetingForm';

export default compose(withNamespaces())(BookMeetingForm);
